import { URLS } from '../../../constants';
import apiClient from '../../client';

const getSessionNoteGrid = {
  getSessionNoteGridApi: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;

    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
  }) =>
    apiClient.post(URLS.sessionNote, {
      data: {
        heading,
        roleId,
        type:
          type === 'allNote' || type === 'All ' ? 'all' : type === 'Published' ? 'published' : '',
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
};

export default getSessionNoteGrid;
